import React, { useEffect, useRef, useState } from "react";
import styles from "./SculptorsSection.module.scss";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import ArtistCard from "components/cards/artistCard/ArtistCard";
import { sculptures } from "mockdata/sculptures";

const SculptorsSection = ({ country }) => {
  const sculptorsWithArtworksRef = useRef();
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (sculptorsWithArtworksRef.current) {
      setMaxHeight(sculptorsWithArtworksRef?.current?.offsetHeight);
    }
  }, []);

  return (
    <div className={styles.paintersSection}>
      <div
        className={styles.paintersWithArtworks}
        ref={sculptorsWithArtworksRef}
      >
        <div className={styles.painterWithArtworksContainer}>
          <div className={styles.painterWithArtworks}>
            <ArtistCard />
            <ArtworkCard item={sculptures[0]} />
            <ArtworkCard item={sculptures[1]} />
          </div>
        </div>
        <div className={styles.painterWithArtworksContainer}>
          <div className={styles.painterWithArtworks}>
            <ArtistCard />
            <ArtworkCard item={sculptures[2]} />
            <ArtworkCard item={sculptures[0]} />
          </div>
        </div>
      </div>
      <div className={styles.paintersFromCountry}>
        <div className={styles.title}>Sculptors From {country}</div>
        {maxHeight ? (
          <div
            className={styles.paintersListContainer}
            style={{
              maxHeight: `${maxHeight}px`,
            }}
          >
            <div className={styles.paintersList}>
              {Array.from(Array(100), (_, index) => (
                <div className={styles.painter} key={index}>
                  Name Lastname
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SculptorsSection;
